module.exports = __webpack_public_path__ + "img/c3596d2.png";